module.exports = __webpack_public_path__ + "archivist_stressed.gif?a39bb0154240ffa8e6803f889237aa28";


//////////////////
// WEBPACK FOOTER
// ./src/img/animazioni/archivist_stressed.gif
// module id = 372
// module chunks = 0